import React, { useState, useEffect } from "react";
import {
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	CircularProgress,
	Box,
} from "@mui/material";
import { generateClient } from "aws-amplify/api";
import { listSeries, seasonsBySeriesID } from "../../graphql/queries";
import { useDispatch, useSelector } from "react-redux";
import {
	setSeries,
	setSeriesID,
} from "../../redux/slices/contentSlice/contentForm/contentForm";
import CreateSeries from "./CreateSeries";
import CreateAndUploadSeries from "./CreateAndUploadSeries";

const Series = ({ formik }) => {
	const client = generateClient();
	const [seriesList, setSeriesList] = useState([]);
	const [selectedSeries, setSelectedSeries] = useState("");
	// const [seriesCreated, setSeriesCreated] = useState(false);
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();

	const seriesCreated = useSelector(
		(state) => state?.batchContentHandler?.seriesCreated
	);

	const fetchSeriesAndSeasons = async () => {
		try {
			setLoading(true);
			const seriesResponse = await client.graphql({
				query: listSeries,
			});
			const seriesList = seriesResponse.data.listSeries.items;
			setSeriesList(seriesList);
		} catch (error) {
			console.error("Error fetching series and seasons:", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchSeriesAndSeasons();
	}, [seriesCreated]);

	const handleChange = (event) => {
		setSelectedSeries(event.target.value);

		dispatch(setSeriesID(event.target.value));
		formik.setFieldValue("seriesId", event.target.value);
	};

	return (
		<Box display={"flex"} gap={1} alignItems={"flex-end"}>
			<FormControl fullWidth variant="outlined">
				<label
					style={{ margin: "10px 0", textWrap: "nowrap" }}
					htmlFor={"select-series"}
				>
					Select Series
					<span style={{ color: "red", marginLeft: "5px" }}>*</span>
				</label>
				{loading ? (
					<CircularProgress />
				) : (
					<Select
						value={selectedSeries}
						onChange={handleChange}
						id={"select-series"}
					>
						{seriesList.map((series) => (
							<MenuItem key={series.id} value={series.id}>
								{series.title}
							</MenuItem>
						))}
					</Select>
				)}
			</FormControl>
			{/* <CreateSeries /> */}
			<CreateAndUploadSeries formik={formik} />
		</Box>
	);
};

export default Series;
